"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventhub = _interopRequireDefault(require("./eventhub"));

var _request = require("./request");

var _simpleCustomErrors = require("simple-custom-errors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var errorHandling = /*#__PURE__*/function () {
  function errorHandling() {
    _classCallCheck(this, errorHandling);
  }

  _createClass(errorHandling, null, [{
    key: "install",
    value: function install(Vue) {
      Vue.prototype.$errors = this;
    }
  }, {
    key: "handle",
    value: function handle(error) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.component) {
        _eventhub["default"].emit("core:errors:vue_".concat(options.component._uid, ":handle"), error, options);
      }

      _eventhub["default"].emit('core:errors:handle', error, options);
    }
  }, {
    key: "clear",
    value: function clear() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.component) {
        _eventhub["default"].emit("core:errors:vue_".concat(options.component._uid, ":clear"), options);
      }

      _eventhub["default"].emit('core:errors:clear', options);
    }
  }, {
    key: "convert",
    value: function convert(error) {
      var errorObject = {
        code: 500,
        error: 'UndefinedError',
        suberror: null,
        message: 'Undefined error',
        stack: error && error.stack,
        details: {},
        i18n: {},
        raw: error
      };

      switch (error instanceof Error) {
        // Handle RequestError
        case error instanceof _request.RequestError:
          errorObject.code = error.params.code || 500;
          errorObject.error = error.code;
          errorObject.suberror = error.params.error;
          errorObject.message = error.params.message;
          errorObject.details = error.params.response.details || {};
          break;
        // Handle SimpleCustomError

        case error instanceof _simpleCustomErrors.SimpleCustomError:
          errorObject.code = 500;
          errorObject.error = error.type;
          errorObject.suberror = error.code;
          errorObject.message = error.message;
          errorObject.details = error.params || {};
          break;
        // Handle a default error

        default:
          errorObject.code = 500;
          errorObject.error = error.message;
          errorObject.message = null;
          errorObject.details = {};
      } // Add i18n details


      errorObject.i18n.path = "errors.".concat(errorObject.error);

      if (errorObject.suberror) {
        errorObject.i18n.path = "".concat(errorObject.i18n.path, ".").concat(errorObject.suberror);
      }

      return errorObject;
    }
  }]);

  return errorHandling;
}();

exports["default"] = errorHandling;